import { forwardRef } from 'react';
import { Picture } from '@ui';
import icons from '@icons';
import StoreInfoSchedule from '../../StoreInfo/components/StoreInfoSchedule';
import { transformScheduleToStoreInfoSchedule } from '@utils/processSchedule';
import { StoreTypeTitles } from '../constants';
import { getStoreAvailableQuantity } from '../utils';
import type { AvailableQuantityItem, StoreListEntry } from '../types';

const {
  phone: { black: phoneFilledBlack },
  clock: { grey: clockFilledGrey }
} = icons.Fill;

interface StoreListItemProps {
  item: StoreListEntry;
  selected: boolean;
  onSelect: () => void;
  isShowAvailableQuantity?: boolean;
  availableQuantity?: AvailableQuantityItem[];
  availableLabelPrefix?: string;
}

const StoreListItem = forwardRef<HTMLDivElement, StoreListItemProps>(
  (
    {
      item,
      selected,
      onSelect,
      isShowAvailableQuantity,
      availableQuantity,
      availableLabelPrefix
    },
    ref
  ) => {
    const quantity = isShowAvailableQuantity
      ? getStoreAvailableQuantity(item.id, availableQuantity)
      : null;

    return (
      <div
        ref={ref}
        data-key={item.id}
        className={`address-item${selected ? ' selected' : ''}`}
        onClick={onSelect}
      >
        <span className='block-address'>
          <div className='full-addres'>
            <div className='deliveryTitle'>
              <div className='title-with-soon'>
                {item.title}
                {item.opens_soon && <div className='deliverySoon'>Скоро</div>}
              </div>
              {isShowAvailableQuantity ? (
                quantity ? (
                  <div className='deliveryAvailable'>
                    {availableLabelPrefix}
                    <span className='deliveryAvailableAmount'>
                      {quantity} шт
                    </span>
                  </div>
                ) : (
                  <div className='deliveryUnavailable'>
                    <span className='deliveryUnavailableText'>
                      Нет в наличии
                    </span>
                  </div>
                )
              ) : null}
            </div>

            {item.type && (
              <div className='deliveryType'>
                {StoreTypeTitles[item.type]}
                {!!item?.metroStations?.length && (
                  <div className='metro-station-container'>
                    <div
                      className='metro-circle'
                      style={{
                        backgroundColor:
                          item.metroStations[0].line?.color || '#ccc'
                      }}
                    />
                    <span
                      className='metro-station-text'
                      style={{
                        color: item.metroStations[0].line?.color || '#666'
                      }}
                    >
                      {item.metroStations[0].title}
                    </span>
                  </div>
                )}
              </div>
            )}

            <div className='deliveryAddress'>{item.address}</div>
            <div className='deliveryContactInfo'>
              {item.phone && (
                <div className='deliveryPhone'>
                  <Picture
                    className='icon'
                    icon={phoneFilledBlack}
                    height='12'
                    alt=''
                  />
                  <a href={`tel:${item.phone}`}>{item.phone}</a>
                </div>
              )}
              <div className='deliverySchedule'>
                <Picture
                  className='icon'
                  icon={clockFilledGrey}
                  height='12'
                  alt=''
                />
                {!!item.schedule?.length && (
                  <StoreInfoSchedule
                    list={transformScheduleToStoreInfoSchedule(item.schedule)}
                    className=''
                    showTimeOnly={true}
                  />
                )}
              </div>
            </div>
          </div>
        </span>
      </div>
    );
  }
);

StoreListItem.displayName = 'StoreListItem';

export default StoreListItem;
